<dx-chart [dataSource]="chartData"
          [pathModified]="true">
    <dxi-chart-series name="Actual"
                      valueField="averageActual">
        <dxo-chart-label [visible]="false"></dxo-chart-label>
    </dxi-chart-series>
    <dxi-chart-series name="Differential"
                      valueField="averageDifferential">
        <dxo-chart-label [visible]="false"></dxo-chart-label>
    </dxi-chart-series>

    <dxo-chart-size [height]="150"></dxo-chart-size>
    <dxo-chart-common-series-settings argumentField="name"
                                      type="stackedbar"
                                      tagField="id">
        <dxo-chart-label [visible]="true">
            <dxo-chart-format type="fixedPoint"
                              [precision]="0"></dxo-chart-format>
        </dxo-chart-label>
    </dxo-chart-common-series-settings>
    <dxo-chart-argument-axis>
        <dxo-chart-label overlappingBehavior="stagger"
                         wordWrap="none"></dxo-chart-label>
    </dxo-chart-argument-axis>
    <dxi-chart-value-axis [visualRange]="[0]"
                          visualRangeUpdateMode="keep"> </dxi-chart-value-axis>
    <dxo-chart-tooltip [enabled]="false"></dxo-chart-tooltip>
    <dxo-chart-legend [visible]="false"></dxo-chart-legend>
</dx-chart>
